<app-modal [modalConfig]="modalConfig">
    <div class="change-password">
        <div class="input-container">
            <label>
                Contraseña Actual
                <span class="mandatory">*</span>
            </label>
            <input class="form-input" [formControl]="oldPassword" type="password" [ngClass]="{'error':hasErrors()}">
        </div>
        <app-password [isLoading]="isLoading" (passwordEvent)="onSubmit($event)"></app-password>
    </div>
    <ngx-ui-loader loaderId="change-password" [hasProgressBar]="false"></ngx-ui-loader>
</app-modal>